import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FiServer, FiMessageCircle } from 'react-icons/fi';
import { FlexBox, Input, Caption } from 'components';
import { createConnection } from 'constants';

const ChatRoom11 = props => {
  const { roomId } = props;

  const [serverUrl, setServerUrl] = useState('https://localhost:1234');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const connection = createConnection(serverUrl, roomId);
    connection.connect();

    return () => {
      connection.disconnect();
    };
  }, [serverUrl, roomId]);

  return (
    <FlexBox wrapped="wrap">
      <Input
        name="serverP11"
        value={serverUrl}
        label="Server URL:"
        placeholder="Type server URL..."
        onChange={e => setServerUrl(e.target.value)}
        icon={<FiServer />}
      />
      <Caption text={`Welcome to the ${roomId} room!`} />
      <Input
        name="messageP11"
        value={message}
        label="Your message:"
        placeholder="Type your message..."
        onChange={e => setMessage(e.target.value)}
        icon={<FiMessageCircle />}
      />
    </FlexBox>
  );
};

ChatRoom11.propTypes = {
  roomId: PropTypes.string.isRequired,
};

export default ChatRoom11;
